import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class RightTriangle extends Symbol2d {

  path (dimensions) {
    const _path = path()
    _path.moveTo(0, 0)
    _path.lineTo(dimensions.width, dimensions.height) // lower right
    _path.lineTo(0, dimensions.height) // lower left
    _path.lineTo(0, 0) // upper left
    _path.closePath()
    return _path.toString()
  }

  textContainer (dimensions) {
    // define the rectangle's width and height as half of the triangle's base and height
    const width = dimensions.width / 2
    const height = dimensions.height / 2

    // Calculate the center of the rectangle
    // Since the rectangle is aligned with the triangle's base and left side,
    // its center would be at (width / 2, dimensions.height - height / 2)
    // Adjusted to ensure the rectangle is fully within the triangle
    const centerX = width / 2
    const centerY = dimensions.height - height / 2

    return {
      center: [centerX, centerY],
      width,
      height
    }
  }

}
